import getHeaders from '../../helpers/headers'
import axios from 'axios'
import config from '../../../constants/endpoints.js'

const {
  endpoints: {
    plugins: {
      trackingUserInfo
    },
  },
} = config


/**
 * Get Tracking User Info
 *
 * @param {String} conversationId Conversation id
 */
export const getTrackingUserInfo = ({ conversationId }) => axios.post(trackingUserInfo, { conversationId }, { headers: getHeaders(true) })

export default getTrackingUserInfo